<script>

    import chroma from "chroma-js";
    
    export let w = 400
    export let h = 600
    export let tile = 100
     const triheight = (1/2) * Math.sqrt(3) * tile
        
        //divide the space up equally
    
    
    const rows = Math.ceil(h/tile)+3
    const cols = Math.ceil(w/triheight) 
    const pointseven = "0,"+triheight+" "+tile/2+",0"+" "+tile+","+triheight
    const pointsodd = "0,0"+" "+tile/2+","+triheight+" "+tile+",0"
    const oddtranslate = (tile/2)*-1;
     
    let fullw = tile*cols
    let fullh = triheight * rows
    
    let xshift = fullw-w
    let yshift = fullh-h
     
    function randomColor(){
            return chroma.hsl(0, 0, Math.random());
        }
        
        function randomNumber() {
            return Math.floor(Math.random() * 360);
        }
        
    
    </script>
    
    <svg viewbox="0 0 {w} {h}">
    <rect width="{w}" height="{h}" x=0 y=0 fill="#eee"/>
        
        {#each Array(rows) as _, i}
    
    <g transform="translate({(i % 2) ? oddtranslate: 0} 0)">
    
            {#each Array(cols*2) as _, ii}
                <g transform="translate({((tile/2)*ii)-(xshift/2)} {(triheight*i)-(yshift/2)})">
                    {#if (ii % 2)}
                    <polygon points="{pointsodd}" x=0 fill="{randomColor()}"/>
                    {:else}
                    <polygon points="{pointseven}" x=0 fill="{randomColor()}"/>
                    {/if}
    <!-- 				<Pattern w={tile} h={tile}/> -->
                </g>
            {/each}
    
        </g>
    
        {/each}
    </svg>
    